import PopularSearchesComponent from "@/components/views/theme/default/seo/PopularSearchesComponent";

const global_routes = [

    //Popular Searches
    {
        path: '/beliebte-suchen/',
        name: 'popular_searches',
        component: PopularSearchesComponent
    }

];

export default global_routes;
